import type {InviteUserRequest} from "@project/sdk/user-management";
import type {InviteUserManagementUserFormPayload} from "./invite-user-management-user.schema";

export const inviteUserManagementUserMapper = {
  toSdk({displayName, email, username}: InviteUserManagementUserFormPayload): InviteUserRequest {
    return {displayName, email, username};
  },
};
